module.exports = __webpack_public_path__ + "static/media/houses-lined-up.25179fd5.png";